import { createContext, useContext } from "react";

const HubLayoutContext = createContext(false);

export const HubLayoutProvider = HubLayoutContext.Provider;

export function useIsHub(): boolean {
  return useContext(HubLayoutContext);
}
